import { Text } from "@chakra-ui/react";
import * as React from "react";
import {
  ActivityFragment,
  CampaignSummaryFragment,
  ReviewMinimalFragment,
} from "../../../graphql/generated/definitions";
import useTranslations from "../../../hooks/useTranslations";
import { ReviewIcon } from "../../icons";
import Link from "../../utils/Link";
import Activity from "../ActivityPlate";

type ReviewCreatedActivity = ActivityFragment & {
  recipient: CampaignSummaryFragment;
  trackable: ReviewMinimalFragment;
};

export function isReviewCreatedActivity(
  q: ActivityFragment
): q is ReviewCreatedActivity {
  return q.key === "review.created";
}

interface ReviewCreatedActivityProps {
  activity: ReviewCreatedActivity;
}

export const ReviewCreatedActivity: React.FC<ReviewCreatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="reviewCreatedActivity"
      visual={<ReviewIcon className="w-10 h-10 text-accent-500" />}
    >
      <Text fontSize="sm">
        {t("activity.labels.reviewCreated", {
          review: (
            <Link to={`/reviews/${activity.trackable.id}`} key="reviewLink">
              {t("activity.objects.review")}
            </Link>
          ),
          collaborator: (
            <Link
              to={`/users/${activity.trackable.collaborator.slug}`}
              key="collaboratorLink"
            >
              {activity.trackable.collaborator.name}
            </Link>
          ),
          title: (
            <Link
              to={`/campaigns/${activity.trackable.campaign.id}`}
              key="campaignLink"
            >
              {activity.trackable.campaign.name}
            </Link>
          ),
        })}
      </Text>
    </Activity>
  );
};
